import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { LOGOUT } from '~/services/auth';
import { ReactComponent as LogoutIcon } from '~/assets/svg/logout.svg';
import { useSession } from '../contexts/SessionProvider';

export const Logout = () => {
  const { t } = useTranslation('navigation');
  const { setDefaultOwner } = useSession();
  const [logout] = useMutation(LOGOUT, {
    variables: {
      data: {
        refresh_token: localStorage.getItem('refreshToken'),
      },
    },
    onCompleted: () => {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      setDefaultOwner();
      window.location.href = '/';
    },
  });

  const handleLogout = () => {
    logout();
  };

  return (
    <button className="mb-12" onClick={handleLogout}>
      <LogoutIcon
        className="h-5 w-5 text-current"
        aria-label={t('Logout.button')}
      />
    </button>
  );
};
